.trigger {
	position: relative;
	display: inline-flex;
}

.badge {
	position: absolute;
	top: calc(-1 * var(--size-3));
	right: calc(-1 * var(--size-3));
	font-size: var(--text-legal);
	background-color: var(--color-primary);
	padding: var(--size-1) var(--size-2);
	border-radius: var(--radius-lg);
	color: var(--gray-100);
	corner-shape: round;
}

.popover {
	padding: var(--size-5);
}

.list {
	all: unset;
	list-style: none;
	display: flex;
	flex-direction: column;
	gap: var(--size-4);
}

.invite {
	display: flex;
	align-items: center;
	gap: var(--size-4);
}

.info {
	display: flex;
	flex-direction: column;
	flex: 1;
}

.meta {
	font-size: var(--text-caption);
	color: var(--color-text-subtle);
}

.actions {
	display: flex;
	align-items: center;
	gap: var(--size-3);
}
